<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-car"
          :title="
            vehicle_id
              ? $i18n.t('Edit Vehicle') +
                (vehicle.regNo ? ' - ' + vehicle.regNo : '')
              : $i18n.t('Create Vehicle') +
                (vehicle.regNo ? ' - ' + vehicle.regNo : '')
          "
          class="px-3 py-1 small-icon"
          color="primary"
        >
          <v-form ref="form" id="form" v-model="isValid">
            <v-col>
              <v-row>
                <v-col cols="12" md="9" lg="9">
                  <v-row>
                    <v-col cols="12" md="12" lg="12">
                      <v-card>
                        <v-row style="padding: 10px 10px">
                          <v-col cols="12" xs="6" sm="4" md="3" lg="3">
                            <v-img
                              v-if="vehicle.pic"
                              :src="vehicle.pic"
                              height="70"
                              width="105"
                            ></v-img>
                            <v-img
                              v-else
                              src="@/assets/truck.png"
                              alt="image not available"
                              height="40"
                              width="60"
                            ></v-img>
                          </v-col>
                          <v-col cols="12" xs="6" sm="4" md="5" lg="5">
                            <h2>{{ vehicle.regNo }}</h2>
                          </v-col>
                          <v-col
                            cols="12"
                            xs="6"
                            sm="4"
                            md="4"
                            lg="4"
                            class="text-right"
                          >
                            <v-chip
                              v-if="vehicle.compliant == 1"
                              small
                              color="green"
                              text-color="white"
                              >Compliance Done</v-chip
                            >
                            <v-chip
                              v-if="vehicle.compliant == 2"
                              small
                              color="red"
                              text-color="white"
                              >Not Compliant</v-chip
                            >
                            <v-chip small v-if="vehicle.compliant == 3"
                              >Compliance Due</v-chip
                            >
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-tabs-items v-model="activeTab">
                        <v-tab-item key="home" style="width: 100%">
                          <v-card flat>
                            <profile
                              :getVehicle="getVehicle"
                              :isEdit="isEdit"
                              :value="vehicle"
                            ></profile>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="photos" style="width: 100%">
                          <v-card flat>
                            <photos @reload="get()" :value="vehicle"></photos>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="settings">
                          <v-card flat>
                            <settings
                              @reload="get()"
                              :value="vehicle"
                            ></settings>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="insurance">
                          <v-card flat>
                            <insurance
                              @reload="get()"
                              :value="vehicle"
                            ></insurance>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="service">
                          <v-card flat>
                            <service @reload="get()" :value="vehicle"></service>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="permits">
                          <v-card flat>
                            <permit @reload="get()" :value="vehicle"></permit>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="fitness">
                          <v-card flat>
                            <fitness @reload="get()" :value="vehicle"></fitness>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="puc">
                          <v-card flat>
                            <p-u-c @reload="get()" :value="vehicle"></p-u-c>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="roadtax">
                          <v-card flat>
                            <road-tax
                              @reload="get()"
                              :value="vehicle"
                            ></road-tax>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="other">
                          <v-card flat>
                            <other @reload="get()" :value="vehicle"></other>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="finance">
                          <v-card flat>
                            <finance @reload="get()" :value="vehicle"></finance>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="sold">
                          <v-card flat>
                            <sold @reload="get()" :value="vehicle"></sold>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="tyre">
                          <v-card flat>
                            <tyre @reload="get()" :value="vehicle"></tyre>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item key="config">
                          <v-card flat>
                            <config @reload="get()" :value="vehicle"></config>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-col>
                  </v-row>

                  <v-row style="padding: 0 20px">
                    <v-btn small fab :to="'/vehicles'" v-if="!singlePage">
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <z-confirm-button
                      v-if="vehicle.showMrkCmpDone"
                      color="green lighten-1"
                      :loading="loading"
                      :message="
                        $i18n.t('Do you want to mark compliance done ?')
                      "
                      @click="markComplicanceDone"
                    >
                      <v-icon>mdi-check</v-icon>
                      {{ $i18n.t("Compliance Done") }}
                    </z-confirm-button>
                    <v-btn
                      color="success"
                      class="mr-0"
                      @click="save()"
                      :loading="loading"
                    >
                      <h3>{{ $i18n.t("Save") }}</h3>
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-card>
                    <v-tabs
                      v-model="activeTab"
                      vertical
                      background-color="white"
                      light
                      color="secondary"
                    >
                      <v-tab key="home" class="float-left justify-start">
                        <v-icon class="me-5">mdi-car-info</v-icon>
                        {{ $i18n.t("Profile") }}
                      </v-tab>

                      <v-tab key="photos" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-image-multiple</v-icon>
                        {{ $i18n.t("Images") }}
                      </v-tab>

                      <v-tab key="settings" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-playlist-plus</v-icon>
                        {{ $i18n.t("Additional Properties") }}
                      </v-tab>

                      <v-tab
                        key="insurance"
                        v-if="isEdit"
                        class="justify-start"
                      >
                        <v-icon class="me-5">mdi-shield-car</v-icon>
                        {{ $i18n.t("Insurance") }}
                      </v-tab>

                      <v-tab key="service" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-garage-alert-variant</v-icon>
                        {{ $i18n.t("Service Details") }}
                      </v-tab>

                      <v-tab key="permits" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-book-open-outline</v-icon>
                        {{ $i18n.t("Permits") }}
                      </v-tab>

                      <v-tab key="fitness" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-briefcase-plus-outline</v-icon>
                        {{ $i18n.t("Fitness Certificate") }}
                      </v-tab>

                      <v-tab key="puc" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-certificate-outline</v-icon>
                        {{ $i18n.t("PUC") }}
                      </v-tab>

                      <v-tab key="roadtax" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-cash-multiple</v-icon>
                        {{ $i18n.t("Road Tax") }}
                      </v-tab>

                      <v-tab key="other" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-cash-plus</v-icon>
                        {{ $i18n.t("Other Expenses") }}
                      </v-tab>

                      <v-tab key="finance" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-cash-usd-outline</v-icon>
                        {{ $i18n.t("Finance Details") }}
                      </v-tab>

                      <v-tab key="sold" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-cart-off</v-icon>
                        {{ $i18n.t("Selling Details") }}
                      </v-tab>

                      <v-tab key="tyre" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-cart-off</v-icon>
                        {{ $i18n.t("Tyre Details") }}
                      </v-tab>

                      <v-tab key="config" v-if="isEdit" class="justify-start">
                        <v-icon class="me-5">mdi-cog</v-icon>
                        {{ $i18n.t("Configuration") }}
                      </v-tab>
                    </v-tabs>
                  </v-card>
                </v-col>
              </v-row>
              <v-row></v-row>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { VueEditor } from "vue2-editor";
import Expenses from "@/views/vehicle/Expenses.vue";
import Config from "@/views/vehicle/Config.vue";
import Finance from "@/views/vehicle/Finance.vue";
import Fitness from "@/views/vehicle/Fitness.vue";
import Insurance from "@/views/vehicle/Insurance.vue";
import Other from "@/views/vehicle/Other.vue";
import Permit from "@/views/vehicle/Permit.vue";
import Photos from "@/views/vehicle/Photos.vue";
import Profile from "@/views/vehicle/Profile.vue";
import PUC from "@/views/vehicle/PUC.vue";
import RoadTax from "@/views/vehicle/RoadTax.vue";
import Service from "@/views/vehicle/Service.vue";
import Settings from "@/views/vehicle/Settings.vue";
import Sold from "@/views/vehicle/Sold.vue";
import Tyre from "@/views/vehicle/Tyre.vue";
import auth from "@/store/user/module/auth";

@Component({
  name: "Vehicle",
  components: {
    VueEditor,
    Expenses,
    Config,
    Finance,
    Fitness,
    Insurance,
    Other,
    Permit,
    Photos,
    Profile,
    PUC,
    RoadTax,
    Service,
    Settings,
    Sold,
    Tyre,
  },
  props: {
    vehicle_id: {
      default: null,
    },
    singlePage: {
      default: false,
    },
  },
})
export default class VehicleEdit extends Vue {
  isValid = true;
  isEdit = false;
  activeTab = null;
  ePage = 1;
  eRows = 30;
  vehicleExpense = {};
  vehiclePOSO = {
    _id: null,
    corp_id: auth.adminOf,
    vehicleDetail: {},
    country: "India",
    driveSide: 1,
    axel: 1,
    transmission: 1,
    status: 1,
    fuelType: "Diesel",
  };
  vehicle = this.vehiclePOSO;
  migrate = {};

  validationrules = {
    regNo: [(v) => !!v || this.$i18n.t("Registration No. is required")],
    vehicleType: [(v) => !!v || this.$i18n.t("Vehicle Type is required")],
    // seats: [(v) => !!v || this.$i18n.t("Seats is required")],
    // color: [(v) => !!v || this.$i18n.t("Color is required")],
    // year: [(v) => !!v || this.$i18n.t("Year is required")],
    country: [(v) => !!v || this.$i18n.t("Country is required")],
    fuelType: [(v) => !!v || this.$i18n.t("Fuel Type is required")],
    // make: [(v) => !!v || this.$i18n.t("Make is Required")],
    // model: [(v) => !!v || this.$i18n.t("Model is required")],
  };

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  addItem(_list) {
    if (!_list) {
      _list = [];
    }
    _list.push({});
    return _list;
  }

  remove(list, index) {
    if (list && index != null && index != undefined) {
      list.splice(index, 1);
    }
  }

  get loading() {
    return common.loading;
  }

  createNew() {
    window.location.href = "/vehicle/create";
  }
  get form() {
    return this.$refs.form;
  }

  preSaveValidation() {
    if (!this.vehicle) {
      common.setError("Tariff Empty");
      return false;
    }
    return this.form.validate();
  }

  async save() {
    try {
      if (!this.preSaveValidation()) {
        return;
      }

      let url_post;
      if (this.isEdit) {
        url_post = "/api/vehicle/" + this.vehicle_id + "/update";
      } else {
        url_post = "/api/vehicle/save";
      }

      common.setLoading(true);
      const vehicle = await doPost(url_post, this.vehicle);
      this.vehicle = vehicle;
      common.setLoading(false);
      common.showMessage(`Vehicle ${vehicle.regNo} Saved Successfully`);

      if (this.singlePage) {
        this.$emit("select", {
          regNo: vehicle.regNo,
          _id: vehicle._id,
        });
        this.vehicle = this.vehiclePOSO;
      } else if (!this.vehicle_id) {
        this.$router.push("/vehicle/" + vehicle._id);
        this.vehicle_id = this.vehicle._id;
        await this.get();
      } else {
        this.vehicle_id = this.vehicle._id;
        await this.get();
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  postFetchVehicle(_vehicle) {
    if (!_vehicle.blockedFor) _vehicle.blockedFor = [];
    if (!_vehicle.vehicleDetail) _vehicle.vehicleDetail = {};
    if (!_vehicle.vehicleDetail.loan) _vehicle.vehicleDetail.loan = {};
    if (!_vehicle.vehicleDetail.loan) _vehicle.vehicleDetail.loan = {};
    if (!_vehicle.vehicleDetail.loan.bank)
      _vehicle.vehicleDetail.loan.bank = {};
    if (!_vehicle.vehicleDetail.loan.bank.address)
      _vehicle.vehicleDetail.loan.bank.address = {};
    if (!_vehicle.vehicleDetail.insurance)
      _vehicle.vehicleDetail.insurance = {};
    if (!_vehicle.vehicleDetail.soldTo) _vehicle.vehicleDetail.soldTo = {};
    if (!_vehicle.vehicleDetail.soldTo.address)
      _vehicle.vehicleDetail.soldTo.address = {};
    if (!_vehicle.vehicleDetail.soldTo.contact)
      _vehicle.vehicleDetail.soldTo.contact = {};
    if (!_vehicle.vehicleDetail.service) _vehicle.vehicleDetail.service = {};
    if (!_vehicle.vehicleDetail.fitness) _vehicle.vehicleDetail.fitness = {};
    if (!_vehicle.vehicleDetail.puc) _vehicle.vehicleDetail.puc = {};
    if (!_vehicle.vehicleDetail.rto) _vehicle.vehicleDetail.rto = {};
    if (!_vehicle.vehicleDetail.tyres) _vehicle.vehicleDetail.tyres = [];

    if (!_vehicle.marketVeh) _vehicle.marketVeh = null;
    if (!_vehicle.ownerInfo) _vehicle.ownerInfo = {};
    if (!_vehicle.ownerInfo.name) _vehicle.ownerInfo.name = null;
    if (!_vehicle.ownerInfo.pan) _vehicle.ownerInfo.pan = null;
    if (!_vehicle.ownerInfo.contactPerson)
      _vehicle.ownerInfo.contactPerson = {};
    if (!_vehicle.ownerInfo.contactPerson.salutation)
      _vehicle.ownerInfo.contactPerson.salutation = "Mr.";
    if (!_vehicle.ownerInfo.contactPerson.name)
      _vehicle.ownerInfo.contactPerson.name = null;
    if (!_vehicle.ownerInfo.contactPerson.email)
      _vehicle.ownerInfo.contactPerson.email = null;
    if (!_vehicle.ownerInfo.contactPerson.countryCode)
      _vehicle.ownerInfo.contactPerson.countryCode = 91;
    if (!_vehicle.ownerInfo.contactPerson.phone)
      _vehicle.ownerInfo.contactPerson.phone = null;
    if (!_vehicle.ownerInfo.contactPerson.otherPhone)
      _vehicle.ownerInfo.contactPerson.otherPhone = null;
    if (!_vehicle.ownerInfo.contactPerson.otherEmail)
      _vehicle.ownerInfo.contactPerson.otherEmail = null;
    if (!_vehicle.ownerInfo.address) _vehicle.ownerInfo.address = {};
    if (!_vehicle.ownerInfo.address.addressLine)
      _vehicle.ownerInfo.address.addressLine = null;
    if (!_vehicle.ownerInfo.address.city)
      _vehicle.ownerInfo.address.city = null;
    if (!_vehicle.ownerInfo.address.state)
      _vehicle.ownerInfo.address.state = null;
    if (!_vehicle.ownerInfo.address.country)
      _vehicle.ownerInfo.address.country = "India";
    if (!_vehicle.ownerInfo.address.pinCode)
      _vehicle.ownerInfo.address.pinCode = null;
  }

  async get() {
    try {
      const vehicle = await doGet(
        "/api/vehicle/" + this.vehicle_id + "/vehicleDetail"
      );
      if (this.isSet(vehicle._id)) {
        this.isEdit = true;
        this.vehicle_id = vehicle._id;

        this.postFetchVehicle(vehicle);

        if (vehicle) this.vehicle = vehicle;
      }
      //   this.fetchMigrateTariffs();
    } catch (e) {
      common.setError(e.message);
    }
  }

  getVehicle(_fetch) {
    if (_fetch) {
      this.get();
    }
  }

  async markComplicanceDone() {
    common.setLoading(true);
    if (this.vehicle._id) {
      try {
        await doGet("/api/vehicle/" + this.vehicle._id + "/compliant/done");
        common.showMessage("Updated Successfully");
        await this.get();
      } catch (e) {
        common.setError(e.message);
      }
    }
    common.setLoading(false);
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  async mounted() {
    if (this.singlePage) {
      if (this.vehicle_id) {
        await this.get();
      }
    } else if (this.$route.params.id) {
      this.vehicle_id = this.$route.params.id;
      await this.get();
    } else {
      if (auth.authContent) {
        this.vehicle.country = auth.authContent.country;
      }
    }
  }
}
</script>
<style scoped>
.tariff-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>
